import { useSuspenseQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_GATE_MOVEMENTS_HISTORY } from '../graphql/queries/getGateMovementsHistory';
import { getMovementHistoryFragmentData } from '../utils/getMovementHistoryFragmentData';

/** `page` es 1-indexado, igual que `StandardListPagination`. */
export const useGateMovementsHistory = (gateId: string, page: number, rowsPerPage: number) => {
  const { data } = useSuspenseQuery(GET_GATE_MOVEMENTS_HISTORY, {
    variables: { gateId, limit: rowsPerPage, offset: (page - 1) * rowsPerPage },
  });

  return useMemo(() => {
    const { unit, precision, history } = data.gate.movements2;
    return {
      items: history.items.map(getMovementHistoryFragmentData),
      pageInfo: history.pageInfo,
      unit,
      precision,
    };
  }, [data]);
};
